/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteToolsetEnvironmentLinkSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteToolsetEnvironmentLinkRequest = {
  /**
   * The ID of the toolset
   */
  toolsetId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteToolsetEnvironmentLinkSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteToolsetEnvironmentLinkSecurity$outboundSchema: z.ZodMiniType<
  DeleteToolsetEnvironmentLinkSecurity$Outbound,
  DeleteToolsetEnvironmentLinkSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteToolsetEnvironmentLinkSecurityToJSON(
  deleteToolsetEnvironmentLinkSecurity: DeleteToolsetEnvironmentLinkSecurity,
): string {
  return JSON.stringify(
    DeleteToolsetEnvironmentLinkSecurity$outboundSchema.parse(
      deleteToolsetEnvironmentLinkSecurity,
    ),
  );
}

/** @internal */
export type DeleteToolsetEnvironmentLinkRequest$Outbound = {
  toolset_id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteToolsetEnvironmentLinkRequest$outboundSchema: z.ZodMiniType<
  DeleteToolsetEnvironmentLinkRequest$Outbound,
  DeleteToolsetEnvironmentLinkRequest
> = z.pipe(
  z.object({
    toolsetId: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      toolsetId: "toolset_id",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteToolsetEnvironmentLinkRequestToJSON(
  deleteToolsetEnvironmentLinkRequest: DeleteToolsetEnvironmentLinkRequest,
): string {
  return JSON.stringify(
    DeleteToolsetEnvironmentLinkRequest$outboundSchema.parse(
      deleteToolsetEnvironmentLinkRequest,
    ),
  );
}
